import {
  Dialog,
  Button,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  DialogActions,
  Stack,
  Grid,
  Checkbox,
  CircularProgress,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Card,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { changeMode, FleetModeType, selectDrivers, selectCars } from "Redux/fleetSlice";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useDrivers from "Hooks/useDrivers";
import useCars from "Hooks/useCars";
import IRAN from "Assets/Images/iran.jpg";
import PLAQUE_FLAG from "Assets/Images/plaqueFlag.jpg";
import { changePlaque } from "Redux/trafficFleetSlice";
import { PLAQUE_ALPHABET } from "Constants/traffic";
import useTrafficFleet from "Hooks/useTrafficFleet";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CarSearch() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { mode, selectedDrivers, selectedCars } = useAppSelector((state) => state.fleet);
  const { plaque } = useAppSelector((state) => state.trafficFleet);

  // const vf = {
  //   code: "ZXIJDDUBSG",
  //   plaque: "۳۴-ن-۱۵۹-۶۷",
  //   buildYear: 1399,
  //   color: "قهوه ای سیر_متا",
  //   status: "enable",
  //   carBrandModelName: "کوییک دنده ای",
  //   chairNumber: 4,
  //   typetitle: "سواری",
  // };

  const [age, setAge] = useState("");
  console.log(plaque, "vrevjdht");

  const handleChange1 = (event: any) => {
    dispatch(changePlaque({ ...plaque, plaquePart1: event.target.value }));
  };

  const handleChange2 = (event: any) => {
    dispatch(changePlaque({ ...plaque, plaquePart2: event.target.value }));
  };

  const handleChange3 = (event: any) => {
    dispatch(changePlaque({ ...plaque, plaquePart3: event.target.value }));
  };

  const handleChange4 = (event: any) => {
    dispatch(changePlaque({ ...plaque, plaquePart4: event.target.value }));
  };

  const data = useTrafficFleet();

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="strech" sx={{ width: "350px" }}>
        <Grid
          item
          xs={2}
          className="fa-number"
          sx={{
            display: "flex",
            textAlign: "center",
            flexDirection: "column",
            border: "1px solid #979797",
            borderRadius: "5px 0 0 5px",
            padding: "5px 0",
            alignItems: "center",
          }}
        >
          <img src={IRAN} alt="flag" style={{ display: "inline-block", width: "50px" }} />
          <TextField
            id="outlined-basic"
            label=""
            variant="outlined"
            sx={{ margin: "auto" }}
            InputProps={{ sx: { height: "30px", width: "50px" }, inputProps: { maxLength: 2 } }}
            onChange={handleChange1}
            value={plaque.plaquePart1}
          />
        </Grid>
        <Grid item xs={9.1} className="fa-number" sx={{ border: "1px solid #979797", display: "flex", alignItems: "center" }}>
          <Grid container justifyContent="space-around" alignItems="center" sx={{ padding: "5px 0", boxSizing: "border-box" }}>
            <Grid item xs={3}>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                InputProps={{ sx: { height: "34px" }, inputProps: { maxLength: 3 } }}
                value={plaque.plaquePart2}
                onChange={handleChange2}
              />
            </Grid>
            <Grid item xs={3.5}>
              <FormControl
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    height: "34px",
                  },
                }}
              >
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={plaque.plaquePart3}
                  label=""
                  onChange={handleChange3}
                  sx={{ height: "500px" }}
                >
                  {PLAQUE_ALPHABET.map((p) => (
                    <MenuItem value={p.value}>{p.text}</MenuItem>
                  ))}
                </Select>
              </FormControl>{" "}
            </Grid>
            <Grid item xs={2.5}>
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                InputProps={{ sx: { height: "34px" }, inputProps: { maxLength: 2 } }}
                value={plaque.plaquePart4}
                onChange={handleChange4}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={0.9}
          sx={{ border: "1px solid #979797", borderRadius: "0 5px 5px 0", display: "flex", alignItems: "center" }}
        >
          <img src={PLAQUE_FLAG} alt="flag" style={{ display: "inline-block", height: "56px", borderRadius: "5px 0 0 5px" }} />
        </Grid>
      </Grid>
    </>
  );
}
